export default {
  api_path: 'https://arbalete-score.fftir.org/api',
  //  api_path: 'http://fft.omikami.net',
  //  api_path: 'http://localhost:3000',
};
